<template>
  <v-container class="white elevation-0" grid-list-xl fluid ma-0 pa-0>

    <v-data-table dense :headers="headers" :items-per-page="50" hide-default-footer :items="configData" :search="search" :loading="loading">
      <template v-slot:item.delete="{ item }">
          <v-avatar size="20" class="red darken-1 mx-1">
            <v-icon small dark  @click=deleteSubscriber(item._id)>delete</v-icon>
          </v-avatar>
      </template>
       <template v-slot:top>
         <v-toolbar flat color="white">
           <v-toolbar-title class="caption mx-0">SUBSCRIBERS</v-toolbar-title>
            <v-divider class="mx-3" inset vertical></v-divider>
            <v-flex sm2 pt-6>
              <v-text-field outlined dense placeholder="Search" class="caption" prepend-inner-icon="search" v-model="search"></v-text-field>
            </v-flex>
              <v-btn depressed large>
                <v-icon class="mx-2" fab xs-small dark @click="exportExcel()">mdi-file-excel</v-icon>
                <v-icon class="mx-2" fab xs-small dark @click.stop="refresh()">mdi-autorenew</v-icon>
              </v-btn>
            <v-spacer></v-spacer>
          </v-toolbar>
       </template>
    </v-data-table>

  </v-container>
</template>

<script>
import ReportServices from '@/services/ReportServices'
import XLSX from 'xlsx'

export default {
  data () {
    return {
      search: '',
      loading: false,
      configData: [],
      headers: [
        {text: 'Email Id', align: 'left', value: 'emailId'},
        {text: 'Created', align: 'left', value: 'dateTime'},
        {text: 'delete', align: 'left', value: 'delete'},
      ],
      Json: {},
      valid: true,
      name: '',
      nameRules: [v => !!v || 'This Field is required'],
    }
  },
  methods: {
    async deleteSubscriber (id) {
      await ReportServices.deleteSubscriber(id)
      setTimeout(() => {
         this.refresh()
      }, 200)
    },
    logoutFromFirebase () {
      this.$store.dispatch('signOutAction')
      .then(() => this.$router.replace('/Signin'))
    },
    exportExcel () {
      var subscribers = XLSX.utils.json_to_sheet(this.configData) 
      var wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, subscribers, 'subscribers')
      XLSX.writeFile(wb, 'subscribers.xlsx')
    },
    async refresh () {
      this.loading = true
      this.configData = (await ReportServices.getSubscribers()).data
      this.loading = false
      this.noDataText = 'No data available'
    },
  },
  async mounted () {
    this.refresh()
  }
}
</script>
